import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Passage from './pages/Passage';
import Paragraph from './pages/Paragraph';
import Sentence from './pages/Sentence';
import ShortSentence from './pages/ShortSentence';
import Word from './pages/Word';
import TranslationQuestion from './pages/TranslationQuestion';
import PassageQuestion from './pages/PassageQuestion';
import WritingSkill from './pages/WritingSkill';
import WritingSkillExample from './pages/WritingSkillExample';
import SchoolAccount from './pages/SchoolAccount';
import CreateAccount from './pages/CreateAccount';
import Subscription from './pages/Subscription';
import DatabaseOverview from './pages/DatabaseOverview';
import DatabaseVersion from './pages/DatabaseVersion';
import { AuthProvider, useAuth } from './utils/AuthContext';
import { DbProvider } from './utils/DbContext';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div className="auth-loading">Loading…</div>;
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <DbProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/passage"
              element={
                <PrivateRoute>
                  <Passage />
                </PrivateRoute>
              }
            />
            <Route
              path="/paragraph"
              element={
                <PrivateRoute>
                  <Paragraph />
                </PrivateRoute>
              }
            />
            <Route
              path="/sentence"
              element={
                <PrivateRoute>
                  <Sentence />
                </PrivateRoute>
              }
            />
            <Route
              path="/short-sentence"
              element={
                <PrivateRoute>
                  <ShortSentence />
                </PrivateRoute>
              }
            />
            <Route
              path="/word"
              element={
                <PrivateRoute>
                  <Word />
                </PrivateRoute>
              }
            />
            <Route
              path="/translation-question"
              element={
                <PrivateRoute>
                  <TranslationQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/passage-question"
              element={
                <PrivateRoute>
                  <PassageQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/writing-skill"
              element={
                <PrivateRoute>
                  <WritingSkill />
                </PrivateRoute>
              }
            />
            <Route
              path="/writing-skill-example"
              element={
                <PrivateRoute>
                  <WritingSkillExample />
                </PrivateRoute>
              }
            />
            <Route
              path="/school-account"
              element={
                <PrivateRoute>
                  <SchoolAccount />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-account"
              element={
                <PrivateRoute>
                  <CreateAccount />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <PrivateRoute>
                  <Subscription />
                </PrivateRoute>
              }
            />
            <Route
              path="/database-version"
              element={
                <PrivateRoute>
                  <DatabaseVersion />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <DatabaseOverview />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </DbProvider>
    </AuthProvider>
  );
}

export default App;
